import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** האם המשתמש ביקש להפחית אנימציות ברמת מערכת ההפעלה/דפדפן */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => window.matchMedia?.(QUERY).matches ?? false);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
